import {createSlice, createAsyncThunk, createEntityAdapter} from "@reduxjs/toolkit";
import {useHttp} from "../../hooks/http.hook";
import {_apiBase} from "../pages/"

const usersAdapter = createEntityAdapter();

const initialState = usersAdapter?.getInitialState({
    usersLoadingStatus: 'idle',
    patientsLoadingStatus: 'idle'
});

// Just for testing

// createAsyncThunk returns 3 actionCreators: pending (= users/requestStatus/pending), fulfilled, rejected - states of the promise
// these are extra reducers (= because outside of the slice
export const fetchUsers = createAsyncThunk(
    'users/fetchUsers', // name space
    () => { // a function which returns a promise for an async code (preferable). For a non-async code we need to handle errors by ourselves
        const {request} = useHttp();
        return request(`${_apiBase}users`);
    }
);

const usersSlice = createSlice( // starting a function for creating a usersSlice
    {
        name: 'users', // 1. arg: name space for the slice (unique)
        initialState, //2. arg:
        reducers: { // place for actionCreators (left)  and corresponding actions (right) - immer for immutability
            usersFetching: state => {
                state.usersLoadingStatus = 'loading';
            },
            usersFetched: (state, action) => {
                state.usersLoadingStatus = 'idle';
                // state.users = action.payload.users;
                usersAdapter?.setAll(state, action?.payload);
                },
            usersFetchingError: state => {
                state.usersLoadingStatus = 'error';
                },
            loggedUserSet: (state, action) => {
                state.loggedUser = action?.payload;
                //usersAdapter?.setOne(state, action?.payload);
                },
            patientsFetching: state => {
                state.patientsLoadingStatus = 'loading';
                },
            patientsFetched: (state, action) => {
                state.patientsLoadingStatus = 'idle';
                // state.patients = action.payload;
                usersAdapter?.setAll(state, action?.payload);
            },
            patientsFetchingError: state => {
                state.patientsLoadingStatus = 'error';
            },

        },
        extraReducers: (builder) => {
            builder?.addCase(
              fetchUsers.pending, state => {state.usersLoadingStatus = 'loading';})?.addCase(
                fetchUsers.fulfilled, (state, action) => {
                    state.usersLoadingStatus = 'idle';
                    //state.users = action.payload;
                    usersAdapter?.setAll(state, action?.payload);
                })
                .addCase(fetchUsers.rejected, state => {state.usersLoadingStatus = 'error';})
                .addDefaultCase(() => {});
        }
    }
);

// tailor the slice in actions and reducer for putting it into the main function for creating the store
const {actions, reducer} = usersSlice;

export default reducer;

export const {
    usersFetching,
    usersFetched,
    usersFetchingError,
    loggedUserSet,
    patientsFetching,
    patientsFetched,
    patientsFetchingError
} = actions;
